// components
import { Button } from "@components/Button";
import { FormWrapper } from "@components/Form";

export const Confirmation = ({ handleOnSubmit }) => (
  <FormWrapper asDiv>
    <Button
      variant="primary"
      type="button"
      size="md"
      onClick={handleOnSubmit}
      className="w-full"
    >
      Back To Login
    </Button>
  </FormWrapper>
);
